import { render, staticRenderFns } from "./invoiced-goods-services.vue?vue&type=template&id=1a826f76&"
import script from "./invoiced-goods-services.vue?vue&type=script&lang=js&"
export * from "./invoiced-goods-services.vue?vue&type=script&lang=js&"
import style0 from "./invoiced-goods-services.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports